import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import "./Navbar.css";
import { useTranslation } from "react-i18next";

function NavScrollExample() {
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 1;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const handleShowModal = () => {
    setShowModal(true);
    setIsChecked(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsChecked(false);
  };

  const handleLinkClick = (path) => {
    setActiveLink(path);
    handleCloseModal();
  };

  const { t } = useTranslation();

  return (
    <>
      <Navbar expand="lg" className={`bg-body-tertiary ${scrolled ? "scrolled" : ""}`} fixed="top" id="navbar">
        <Container fluid className="justify-content-center">
          <label className="hamburger d-lg-none" aria-label="Menu">
            <input type="checkbox" checked={isChecked} onChange={handleShowModal} />
            <div className="switch">
              <span className="line-1"></span>
              <span className="line-2"></span>
              <span className="line-3"></span>
            </div>
          </label>
          <Nav
            className="d-none d-lg-flex me-auto my-2 my-lg-0 justify-content-center"
            style={{ gap: "50px" }}
            id="navbar"
          >
            <Link
              to="/"
              className={`nav-link text-dark ${activeLink === "/" ? "active" : ""}`}
              onClick={() => handleLinkClick("/")}
            >
              Home
            </Link>
            <Link
              to="/menu"
              className={`nav-link text-dark ${activeLink === "/menu" ? "active" : ""}`}
              onClick={() => handleLinkClick("/menu")}
            >
              {t("navbar2")}
            </Link>
            <Navbar.Brand href="#">
              <img src="/img/immagini/logoor.png" alt="" style={{ width: "57px" }} />
            </Navbar.Brand>
            <Link
              to="/galleria"
              className={`nav-link text-dark ${activeLink === "/galleria" ? "active" : ""}`}
              onClick={() => handleLinkClick("/galleria")}
            >
              {t("navbar3")}
            </Link>
            <a
              href="#end"
              className={`nav-link text-dark ${activeLink === "/#end" ? "active" : ""}`}
              onClick={() => handleLinkClick("/#end")}
            >
              {t("navbar4")}
            </a>
          </Nav>
        </Container>
      </Navbar>

      <Modal show={showModal} onHide={handleCloseModal} centered dialogClassName="modal-water-effect">
        <Modal.Header closeButton>
          <Modal.Title>Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav className="flex-column">
            <Link
              to="/"
              className={`nav-link text-dark ${activeLink === "/" ? "active" : ""}`}
              onClick={() => handleLinkClick("/")}
            >
              {t("navbar1")}
            </Link>
            <Link
              to="/menu"
              className={`nav-link text-dark ${activeLink === "/menu" ? "active" : ""}`}
              onClick={() => handleLinkClick("/menu")}
            >
              {t("navbar2")}
            </Link>
            <Link
              to="/galleria"
              className={`nav-link text-dark ${activeLink === "/galleria" ? "active" : ""}`}
              onClick={() => handleLinkClick("/galleria")}
            >
              {t("navbar3")}
            </Link>
            <a
              href="#end"
              className={`nav-link text-dark ${activeLink === "/#end" ? "active" : ""}`}
              onClick={() => handleLinkClick("/#end")}
            >
              {t("navbar4")}
            </a>
          </Nav>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NavScrollExample;
